import { ListCustomizer } from '@kinet-open-network/client/core/forms/ui';
import { Customer } from '@kinet-open-network/client/customers/data-access';
import { CustomersListComponent } from '@kinet-open-network/client/customers/feature/list';

export const customersListCustomization: ListCustomizer<
  Customer,
  CustomersListComponent
> = () => ({
  columns: [
    {
      key: 'deliveryFeeSku',
      label: 'Poplatok za doručenie (SKU)',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'isSupplier',
      label: 'Dodávateľ',
      filter: 'boolean',
      hidden: true,
    },
    {
      key: 'isFillingPlant',
      label: 'Plniareň',
      filter: 'boolean',
      hidden: true,
    },
    {
      key: 'paymentType',
      label: 'Spôsob platby',
      filter: 'text',
      hidden: true,
    },
  ],
});
